<template>
    <div class="container-fluid content-wrapper">
        <div class="content-heading">
            <!-- Nothing is said about the report until the list has loaded: opened directly,
                 every report would otherwise look deleted for a moment. -->
            <div>
                <small>Activity</small>
                <template v-if="report">{{ report.name }}</template>
                <template v-else-if="loaded">A report that has since been deleted</template>
            </div>
        </div>
        <div v-if="report || loaded" class="small mb-2">
            <router-link v-if="report" :to="`/reports/ai/${id}`">← Back to the report</router-link>
            <router-link v-else to="/reports/ai">← AI Reports</router-link>
        </div>

        <!-- The history outlives the report, so it still shows after a delete. -->
        <ReportActivity :report-definition-id="Number(id)" />
    </div>
</template>

<script>
// One saved AI report's activity: the Activity tab's log, filtered to this report.
import { useAiReportsStore } from '@/stores/aiReports';
import ReportActivity from '@/views/Reports/Agent/ReportActivity.vue';

export default {
    name: 'AiReportActivity',
    components: { ReportActivity },
    props: { id: { type: String, required: true } },
    computed: {
        report() {
            return useAiReportsStore().getById(this.id) || null;
        },
        loaded() {
            return useAiReportsStore().loaded;
        },
    },
    created() {
        useAiReportsStore().load();
    },
};
</script>
